import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['backdrop', 'panel', 'content']

  connect() {
    this.returnCtx = this.data.get('return')
    this.pipelineId = this.data.get('pipeline')
    this.onClick = this.onClick.bind(this)
    this.onKey = this.onKey.bind(this)
    this.element.addEventListener('click', this.onClick)
    document.addEventListener('keydown', this.onKey)
  }

  disconnect() {
    this.element.removeEventListener('click', this.onClick)
    document.removeEventListener('keydown', this.onKey)
  }

  onClick(e) {
    // Real controls (archive button, forms, the title link) are left untouched.
    if (e.target.closest('button, a, form, input, select, label')) return
    const card = e.target.closest('.crm-card')
    if (!card || !card.dataset.oppId) return
    e.preventDefault()
    this.open(card.dataset.oppId)
  }

    // Plain click opens the panel; ⌘/Ctrl/middle click keeps the native new-tab behaviour.
  openFromLink(e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return
    e.preventDefault()
    const card = e.target.closest('.crm-card')
    if (card && card.dataset.oppId) this.open(card.dataset.oppId)
  }

  open(id) {
    const params = new URLSearchParams()
    if (this.returnCtx) params.set('return', this.returnCtx)
    if (this.pipelineId) params.set('pipeline_id', this.pipelineId)
    this.contentTarget.innerHTML = this.spinner()
    this.show()
    fetch(`/crm/opportunities/${id}/panel?${params.toString()}`, {
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then((r) => { if (!r.ok) throw new Error('panel failed'); return r.text() })
      .then((html) => { this.contentTarget.innerHTML = html })
      .catch(() => { this.contentTarget.innerHTML = this.errorState() })
  }

  show() {
    this.panelTarget.classList.remove('translate-x-full')
    this.backdropTarget.classList.remove('opacity-0', 'pointer-events-none')
    this.backdropTarget.classList.add('opacity-100')
    document.body.style.overflow = 'hidden'
  }

  close() {
    this.panelTarget.classList.add('translate-x-full')
    this.backdropTarget.classList.add('opacity-0', 'pointer-events-none')
    this.backdropTarget.classList.remove('opacity-100')
    document.body.style.overflow = ''
  }

  onKey(e) {
    if (e.key === 'Escape' && !this.panelTarget.classList.contains('translate-x-full')) this.close()
  }

  spinner() {
    return '<div class="h-full grid place-items-center text-slate-300"><i class="fas fa-circle-notch fa-spin text-[20px]"></i></div>'
  }

  errorState() {
    return '<div class="h-full grid place-items-center text-slate-400 text-[13px]">Impossible de charger l\'opportunité.</div>'
  }
}
